import { render, staticRenderFns } from "./FinishSetup.vue?vue&type=template&id=0bc9cbc2&scoped=true&"
import script from "./FinishSetup.vue?vue&type=script&lang=js&"
export * from "./FinishSetup.vue?vue&type=script&lang=js&"
import style0 from "./FinishSetup.vue?vue&type=style&index=0&id=0bc9cbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc9cbc2",
  null
  
)

export default component.exports